import { useTranslation } from 'react-i18next'
import { FieldProps, REASON_CLASSIFIER_KEY } from './constants'
import { Select, SelectItem } from '@calabriocloud/beacon-ui'

export const ReasonField = ({ classifier, field, onChange }: FieldProps) => {
  const { t } = useTranslation()
  const baseValue = { classifierType: classifier.id, fieldKey: null }

  const handleChange = (key: number) => {
    const selectedItem = REASON_CLASSIFIER_KEY.find(item => item.id === key)
    if (selectedItem) {
      onChange({
        ...baseValue,
        field: selectedItem.id.toString(),
        name: `${t(classifier.name)}: ${t(selectedItem.name)}`,
      })
    }
  }

  return (
    <div className='flex flex-row gap-4 pb-4'>
      <Select
        label={t(classifier.name)}
        className='w-80'
        name='reasonFieldId'
        data-testid='classifier-reason-select'
        onSelectionChange={handleChange}
        selectedKey={field?.field ? parseInt(field.field) : undefined}
        items={REASON_CLASSIFIER_KEY}>
        {item => (<SelectItem key={item.id} id={item.id}>{t(item.name)}</SelectItem>)}
      </Select>
    </div>
  )
}
